import { useEffect, useState } from "react";

import { LOGIN_URL, SIGNUP_URL } from "@/constants/links";

const NAV_LINKS = [
    { href: "#problem", label: "The problem" },
    { href: "#what", label: "What C-ORE is" },
    { href: "#layers", label: "The three layers" },
    { href: "#pricing", label: "Pricing" },
];

export default function Nav({ onOpenDemo }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleOpenDemo = () => {
        setOpen(false);
        onOpenDemo?.();
    };

    return (
        <nav
            className={`nav ${scrolled ? "is-scrolled" : ""}`}
            data-testid="v2-nav"
        >
            <div className="container nav__inner">
                <a
                    className="nav__brand"
                    href="/#top"
                    aria-label="C-ORE — home"
                    data-testid="v2-nav-brand"
                >
                    <img
                        src="/img/core-logo.png"
                        alt="C-ORE"
                        width="100"
                        height="22"
                    />
                </a>

                <div className="nav__links" aria-label="Primary">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="nav__link"
                            data-testid={`v2-nav-link-${l.href.slice(1)}`}
                        >
                            {l.label}
                        </a>
                    ))}
                </div>

                <div className="nav__actions">
                    <a
                        className="btn btn--ghost btn--sm"
                        href={LOGIN_URL}
                        data-testid="v2-nav-login"
                    >
                        Log in
                    </a>
                    <button
                        type="button"
                        className="btn btn--secondary btn--sm"
                        onClick={handleOpenDemo}
                        data-testid="v2-nav-book-demo"
                    >
                        Book a demo call
                    </button>
                    <a
                        className="btn btn--primary btn--sm"
                        href={SIGNUP_URL}
                        data-testid="v2-nav-start-trial"
                    >
                        Start 15-day trial
                    </a>
                </div>

                <button
                    type="button"
                    className="nav__burger"
                    aria-label="Toggle menu"
                    aria-expanded={open}
                    onClick={() => setOpen((v) => !v)}
                    data-testid="v2-nav-burger"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    >
                        {open ? (
                            <>
                                <line x1="5" y1="5" x2="19" y2="19" />
                                <line x1="19" y1="5" x2="5" y2="19" />
                            </>
                        ) : (
                            <>
                                <line x1="4" y1="7" x2="20" y2="7" />
                                <line x1="4" y1="12" x2="20" y2="12" />
                                <line x1="4" y1="17" x2="20" y2="17" />
                            </>
                        )}
                    </svg>
                </button>
            </div>

            <div
                className={`nav__mobile ${open ? "is-open" : ""}`}
                data-testid="v2-nav-mobile"
            >
                {NAV_LINKS.map((l) => (
                    <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
                        {l.label}
                    </a>
                ))}
                <div className="nav__mobile-actions">
                    <a className="btn btn--secondary btn--block" href={LOGIN_URL}>
                        Log in
                    </a>
                    <button
                        type="button"
                        className="btn btn--primary btn--block"
                        onClick={handleOpenDemo}
                        data-testid="v2-nav-mobile-book-demo"
                    >
                        Book a demo call
                    </button>
                </div>
            </div>
        </nav>
    );
}
